<div class="container-fluid m-0 p-0" *ngIf="!showLoader">
    <form [formGroup]="updateQuestion" (change)="updateQuestionChange()" (submit)="updateQuestionSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{ "UPDATE_QUESTION" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/admission/questions"
                    *ngIf="!updating">
                    {{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!updating"><i
                        class="fas fa-plus"></i>
                    {{ "UPDATE" | translate | titlecase }}</button>
                <app-loader [show]="updating"></app-loader>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "QUESTION_DESC_AR" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="questionDescAr">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateQuestion.controls.questionDescAr.touched && updateQuestion.controls.questionDescAr.invalid && updateQuestion.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "QUESTION_DESC_EN" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="questionDescEn">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateQuestion.controls.questionDescEn.touched && updateQuestion.controls.questionDescEn.invalid && updateQuestion.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "QUESTION_TYPE" | translate | titlecase }}</label>
                                <select class="form-control" [(ngModel)]="selectedQuestionType" formControlName="questionType" (change)="changeQuestionType()" [attr.disabled]="true">
                                    <option value="">{{ "PLEASE_SELECT" | translate | titlecase }}</option>
                                    <option value="TEXT">{{ "TEXT" | translate | titlecase }}</option>
                                    <option value="LIST">{{ "LIST" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateQuestion.controls.questionType.touched && updateQuestion.controls.questionType.invalid && updateQuestion.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "ACTIVE_FLAG" | translate | titlecase }}</label>
                                <select class="form-control" formControlName="activeFlag" [(ngModel)]="selectedActiveFlag" >
                                    <option value="">{{ "PLEASE_SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{ "YES" | translate | titlecase }}</option>
                                    <option value="NO">{{ "NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateQuestion.controls.activeFlag.touched && updateQuestion.controls.activeFlag.invalid && updateQuestion.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "SECTION_NO" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="sectionNo">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateQuestion.controls.sectionNo.touched && updateQuestion.controls.sectionNo.invalid && updateQuestion.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "ORDER_NUMBER" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="orderNo">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateQuestion.controls.orderNo.touched && updateQuestion.controls.orderNo.invalid && updateQuestion.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "REQUIRED" | translate | titlecase }}</label>
                                <select class="form-control" [(ngModel)]="selectedRequiredFlag" formControlName="requiredFlag">
                                    <option value="">{{ "PLEASE_SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{ "YES" | translate | titlecase }}</option>
                                    <option value="NO">{{ "NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="updateQuestion.controls.requiredFlag.touched && updateQuestion.controls.requiredFlag.invalid && updateQuestion.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div class="row" *ngIf="showQuestionAnswer">
                            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                                <button type="button" class="btn btn-primary m-2 rounded-0" data-toggle="modal"
                                    data-target="#questionAnswer" (click)="clearAddQuestionAnswerForm()"><i class="fas fa"></i>
                                    {{ "ADD_QUESTION_ANSWER" | translate | titlecase }}</button>
                            </div>
                        </div>
                        <br/>
                        <br/>
                        <div class="bg-white border pt-3 my-4" *ngIf="questionAnswers.length >= 1" id="questionAnswerTable">
                            <h5 class="font-16 font-black px-3">{{ "QUESTIONS_MANAGEMENT" | translate | titlecase }}</h5>
                                <table  class="table-striped display nowrap" id="datatable" style="width:100%">
                                    <thead>
                                        <tr>
                                            <th>{{ "ANSWER_AR" | translate | titlecase }}</th>
                                            <th>{{ "ANSWER_EN" | translate | titlecase }}</th>
                                            <th>{{ "ORDER_NUMBER" | translate | titlecase }}</th>
                                            <th class="border-0 font-14 px-2 text-grey">{{ "MODIFY" | translate | titlecase }}</th>
                                            <th class="border-0 font-14 px-2 text-grey">{{ "DELETE" | translate | titlecase }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let res of questionAnswers; let i = index">
                                            <td>{{res?.valueDescAr}}</td>
                                            <td>{{res?.valueDescEn}}</td>
                                            <td>{{res?.orderNo}}</td>
                                            <td class="text-bold text-warning">
                                                <button type="button" class="btn btn-sm btn-link text-warning" (click)="editQuestionAnswer(i)" data-toggle="modal"
                                                data-target="#updateQuestionAnswer"><i
                                                        class="fas fa-edit"></i>
                                                        {{ "MODIFY" | translate | titlecase }}</button>
                                            </td>
                                            <td class="text-bold text-danger">
                                                <button class="btn btn-sm btn-link text-danger" (click)="deleteQuestionAnswer(i)"><i
                                                        class="fas fa-trash"></i>
                                                        {{ "DELETE" | translate | titlecase }}</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<!-- Adding question answer-->
<div class="modal fade" id="questionAnswer" tabindex="-1" aria-labelledby="questionAnswer" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <form class="modal-content col-md-12" [formGroup]="questionAnswerPopUp" (submit)="addQuestionAnswer()">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "ADD_QUESTION_ANSWER" | translate | titlecase }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeAddQuestionAnswerModel>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body px-md-12">
                <div class="row">
                    <div class="col-md-5 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ANSWER_AR" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="valueDescAr">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="questionAnswerPopUp.controls.valueDescAr.touched && questionAnswerPopUp.controls.valueDescAr.invalid && questionAnswerPopUp.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-7 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ANSWER_EN" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="valueDescEn">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="questionAnswerPopUp.controls.valueDescEn.touched && questionAnswerPopUp.controls.valueDescEn.invalid && questionAnswerPopUp.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ORDER_NUMBER" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="orderNo">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="questionAnswerPopUp.controls.orderNo.touched && questionAnswerPopUp.controls.orderNo.invalid && questionAnswerPopUp.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-ChronicDiseases" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>

<!-- update question answer -->
<div class="modal fade" id="updateQuestionAnswer" tabindex="-1" aria-labelledby="updateQuestionAnswer" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <form class="modal-content col-md-12" [formGroup]="updateQuestionAnswerPopUp" (submit)="updateQuestionAnswerSubmit()">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "EDIT_QUESTION_ANSWER" | translate | titlecase }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeEditQuestionAnswerModel>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body px-md-12">
                <div class="row">
                    <div class="col-md-5 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ANSWER_AR" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="valueDescAr">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="questionAnswerPopUp.controls.valueDescAr.touched && questionAnswerPopUp.controls.valueDescAr.invalid && questionAnswerPopUp.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                    <div class="col-md-7 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ANSWER_EN" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="valueDescEn">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="questionAnswerPopUp.controls.valueDescEn.touched && questionAnswerPopUp.controls.valueDescEn.invalid && questionAnswerPopUp.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 form-group px-md-5 mb-4">
                        <label class="font-bold">{{ "ORDER_NUMBER" | translate | titlecase }}</label>
                        <input type="text" class="form-control" formControlName="orderNo">
                        <div class="alert alert-danger px-3 p-1 mt-1"
                            *ngIf="questionAnswerPopUp.controls.orderNo.touched && questionAnswerPopUp.controls.orderNo.invalid && questionAnswerPopUp.dirty">
                            {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="close-ChronicDiseases" class="btn btn-outline-secondary"
                    data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
            </div>
        </form>
    </div>
</div>

<app-loader [show]="showLoader"></app-loader>